@if (showHeader) {
  <app-header></app-header>
}
<main [class.is-full-bleed]="true">
  <router-outlet></router-outlet>
</main>
@if (showFooter) {
  <app-footer></app-footer>
}
